// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.compact-dropdown {\n    height: 24px;\n    padding-top: 3px !important;\n    padding-bottom: 3px !important;\n}\n", ""]);
// Exports
module.exports = exports;
